(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const popupDelay = 10000;
  const pageStartedAt = performance.now();
  let userInteracted = false;
  let scheduled = false;

  const rememberInteraction = () => {
    userInteracted = true;
  };

  document.addEventListener('pointerdown', rememberInteraction, { once: true, passive: true });
  document.addEventListener('keydown', rememberInteraction, { once: true });

  const setMobileAutoplay = () => {
    document
      .querySelectorAll('slideshow-component, announcement-bar-component')
      .forEach((component) => {
        if (!(component instanceof HTMLElement)) return;

        if (mobileQuery.matches) {
          if (component.hasAttribute('autoplay') && !component.dataset.ovAutoplay) {
            component.dataset.ovAutoplay = component.getAttribute('autoplay') || '';
          }
          component.removeAttribute('autoplay');
          if (typeof component.pause === 'function') component.pause();
          else if (typeof component.suspend === 'function') component.suspend();
          return;
        }

        if (component.dataset.ovAutoplay !== undefined) {
          component.setAttribute('autoplay', component.dataset.ovAutoplay);
          delete component.dataset.ovAutoplay;
          component.removeAttribute('paused');
          if (typeof component.resume === 'function') component.resume();
          else if (typeof component.play === 'function') component.play();
        }
      });
  };

  const popupLooksAutomatic = (dialog) => {
    const signature = [
      dialog.id,
      dialog.className,
      dialog.getAttribute('aria-label'),
      dialog.getAttribute('data-testid')
    ]
      .filter(Boolean)
      .join(' ');

    return /(newsletter|email|subscribe|promotion|promo|discount|welcome)/i.test(signature);
  };

  const delayEarlyAutomaticPopups = () => {
    if (!mobileQuery.matches || userInteracted) return;

    const elapsed = performance.now() - pageStartedAt;
    if (elapsed >= popupDelay) return;

    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (!popupLooksAutomatic(dialog) || dialog.dataset.ovPopupDelayed === 'true') return;

      dialog.dataset.ovPopupDelayed = 'true';
      dialog.close();
      window.setTimeout(() => {
        if (!dialog.isConnected || dialog.open) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }, Math.max(0, popupDelay - elapsed));
    });
  };

  const bottomObstacleSelectors = [
    '#shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '[id*="cookie" i]',
    '[class*="cookie-banner" i]',
    '[class*="cookie-consent" i]',
    '[aria-label*="cookie" i]',
    '#ShopifyChat',
    '[id*="shopify-chat" i]',
    'iframe[title*="chat" i]',
    'iframe[src*="chat" i]',
    '[class*="chat-widget" i]',
    '[class*="chat-bubble" i]'
  ].join(',');

  const updateStickySafeBottom = () => {
    scheduled = false;

    if (!mobileQuery.matches || !document.querySelector('sticky-add-to-cart')) {
      document.documentElement.style.removeProperty('--ov-sticky-safe-bottom');
      return;
    }

    let safeBottom = 0;
    document.querySelectorAll(bottomObstacleSelectors).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (element.closest('sticky-add-to-cart')) return;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity || 1) > 0 &&
        rect.width > 0 &&
        rect.height > 0;
      const isFloating = style.position === 'fixed' || style.position === 'sticky';
      const touchesBottom = rect.bottom >= window.innerHeight - 8 && rect.top < window.innerHeight;

      if (isVisible && isFloating && touchesBottom) {
        safeBottom = Math.max(safeBottom, window.innerHeight - rect.top + 8);
      }
    });

    safeBottom = Math.min(safeBottom, Math.round(window.innerHeight * 0.45));
    document.documentElement.style.setProperty('--ov-sticky-safe-bottom', safeBottom + 'px');
  };

  const scheduleRefresh = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      setMobileAutoplay();
      delayEarlyAutomaticPopups();
      updateStickySafeBottom();
    });
  };

  const observer = new MutationObserver(scheduleRefresh);

  const init = () => {
    setMobileAutoplay();
    delayEarlyAutomaticPopups();
    updateStickySafeBottom();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'hidden', 'class', 'style', 'aria-hidden']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  mobileQuery.addEventListener('change', scheduleRefresh);
  window.addEventListener('resize', scheduleRefresh, { passive: true });
  window.addEventListener('orientationchange', scheduleRefresh, { passive: true });
  window.setTimeout(scheduleRefresh, popupDelay + 50);
})();
